'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _rollupPluginBabelHelpers = require('../../../../_virtual/_rollupPluginBabelHelpers.js');
var React = require('react');
var React__default = _interopDefault(React);
var PropTypes = _interopDefault(require('prop-types'));
var Link = require('../../00.helper/Link/Link.js');
var classNames = _interopDefault(require('classnames/dedupe'));
var Icon = require('../../01.atoms/Icon/Icon.js');
var MaterialDrop = require('../../01.atoms/MaterialDrop/MaterialDrop.js');
var globals = require('../../../utils/globals.js');
var reactRouter = require('react-router');
var Menu = require('../../02.molecules/Menu/Menu.js');
var UserItem = require('../../02.molecules/UserItem/UserItem.js');
require('./_index.scss.js');

var CLASSNAME = 'varta-header',
    cnFixed = "".concat(CLASSNAME, "--fixed"),
    cnHidden = "".concat(CLASSNAME, "--hidden"),
    cnWrapper = "".concat(CLASSNAME, "__wrapper"),
    cnMenu = "".concat(CLASSNAME, "__menu"),
    cnMenuIcon = "".concat(cnMenu, "__icon"),
    cnMenuTitle = "".concat(cnMenu, "__title"),
    cnLogo = "".concat(CLASSNAME, "__logo"),
    cnLogoImage = "".concat(cnLogo, "__image"),
    cnLogoLink = "".concat(cnLogo, "__link");
/**
 * 
 */

var Header = /*#__PURE__*/function (_React$Component) {
  _rollupPluginBabelHelpers.inherits(Header, _React$Component);

  var _super = _rollupPluginBabelHelpers.createSuper(Header);

  function Header() {
    var _this;

    _rollupPluginBabelHelpers.classCallCheck(this, Header);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _rollupPluginBabelHelpers.defineProperty(_rollupPluginBabelHelpers.assertThisInitialized(_this), "state", {
      open: false
    });

    _rollupPluginBabelHelpers.defineProperty(_rollupPluginBabelHelpers.assertThisInitialized(_this), "menuButton", /*#__PURE__*/React__default.createRef());

    _rollupPluginBabelHelpers.defineProperty(_rollupPluginBabelHelpers.assertThisInitialized(_this), "menu", /*#__PURE__*/React__default.createRef());

    _rollupPluginBabelHelpers.defineProperty(_rollupPluginBabelHelpers.assertThisInitialized(_this), "onRouteChangeStart", function () {
      _this.setState({
        open: false
      });
    });

    _rollupPluginBabelHelpers.defineProperty(_rollupPluginBabelHelpers.assertThisInitialized(_this), "onScroll", function () {
      if (!_this.ticking) {
        requestAnimationFrame(_this.update);
      }

      _this.ticking = true;
    });

    _rollupPluginBabelHelpers.defineProperty(_rollupPluginBabelHelpers.assertThisInitialized(_this), "onScrollEnd", function () {
      _this.firstScrollPosition = undefined;
    });

    _rollupPluginBabelHelpers.defineProperty(_rollupPluginBabelHelpers.assertThisInitialized(_this), "update", function () {
      var _this$props = _this.props,
          mobile = _this$props.mobile,
          breakpoint = _this$props.breakpoint,
          tablet = breakpoint === 'md' || mobile;

      _this.clearScrollTimeout();

      if (!tablet) {
        _this.ticking = false;
        return;
      }

      _this.scrollTimeout = setTimeout(_this.onScrollEnd, 250);

      if (typeof _this.firstScrollPosition === 'undefined') {
        _this.firstScrollPosition = window.scrollY;
      }

      if (window.scrollY < 10) {
        _this.showMenu();
      } else if (window.scrollY - _this.firstScrollPosition > 80) {
        _this.hideMenu();
      } else if (window.scrollY - _this.firstScrollPosition < -20) {
        _this.showMenu();
      }

      var direction = _this.prevScrollPosition - window.scrollY < 0 ? 1 : -1;

      if (direction !== _this.direction) {
        _this.firstScrollPosition = undefined;
      }

      _this.direction = direction;
      _this.prevScrollPosition = window.scrollY;
      _this.ticking = false;
    });

    _rollupPluginBabelHelpers.defineProperty(_rollupPluginBabelHelpers.assertThisInitialized(_this), "onClickOutside", function (e) {
      var target = e.target;

      if (_this.menuButton.current && !_this.menuButton.current.contains(target) && _this.menu.current && !_this.menu.current.contains(target)) {
        _this.setState({
          open: false
        });
      }
    });

    return _this;
  }

  _rollupPluginBabelHelpers.createClass(Header, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      window.addEventListener('click', this.onClickOutside);
      this.unlisten = reactRouter.browserHistory === null || reactRouter.browserHistory === void 0 ? void 0 : reactRouter.browserHistory.listen(function (location) {
        _this2.onRouteChangeStart.bind(_this2);
      });
      window.addEventListener('scroll', this.onScroll);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _this3 = this;

      window.removeEventListener('click', this.onClickOutside);
      this.unlisten = reactRouter.browserHistory === null || reactRouter.browserHistory === void 0 ? void 0 : reactRouter.browserHistory.listen(function (location) {
        _this3.onRouteChangeStart.bind(_this3);
      });
      window.removeEventListener('scroll', this.onScroll);
      this.clearScrollTimeout();
    }
  }, {
    key: "showMenu",
    value: function showMenu() {
      var hidden = this.state.hidden;

      if (!hidden) {
        return;
      }

      this.setState({
        hidden: false
      });
    }
  }, {
    key: "hideMenu",
    value: function hideMenu() {
      var _this$state = this.state,
          hidden = _this$state.hidden,
          open = _this$state.open;

      if (hidden || open) {
        return;
      }

      this.setState({
        hidden: true
      });
    }
  }, {
    key: "clearScrollTimeout",
    value: function clearScrollTimeout() {
      if (this.scrollTimeout) {
        clearTimeout(this.scrollTimeout);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _classNames,
          _this4 = this;

      var _this$props2 = this.props,
          profile = _this$props2.profile,
          items = _this$props2.items,
          logoSource = _this$props2.logoSource,
          menuItems = _this$props2.menuItems,
          languages = _this$props2.languages,
          locale = _this$props2.locale,
          fixed = _this$props2.fixed,
          mobile = _this$props2.mobile,
          breakpoint = _this$props2.breakpoint,
          userLink = _this$props2.userLink,
          onShowAll = _this$props2.onShowAll,
          onLoginMore = _this$props2.onLoginMore,
          onUserItemOpen = _this$props2.onUserItemOpen,
          onLanguageSave = _this$props2.onLanguageSave,
          users = _this$props2.users,
          onUserClick = _this$props2.onUserClick,
          onForgetLogin = _this$props2.onForgetLogin,
          i18n = _this$props2.i18n,
          contactLink = _this$props2.contactLink,
          _this$state2 = this.state,
          open = _this$state2.open,
          hidden = _this$state2.hidden;
      return /*#__PURE__*/React__default.createElement("header", {
        className: classNames(CLASSNAME, (_classNames = {}, _rollupPluginBabelHelpers.defineProperty(_classNames, cnFixed, fixed), _rollupPluginBabelHelpers.defineProperty(_classNames, cnHidden, hidden), _classNames))
      }, /*#__PURE__*/React__default.createElement("div", {
        className: cnWrapper
      }, /*#__PURE__*/React__default.createElement("button", {
        className: cnMenu,
        onClick: function onClick() {
          _this4.setState({
            open: !open
          });
        },
        ref: this.menuButton,
        "data-type": "header",
        "data-function": "menu"
      }, /*#__PURE__*/React__default.createElement(Icon, {
        className: cnMenuIcon,
        id: open ? 'times' : 'menu',
        size: "sm"
      }), /*#__PURE__*/React__default.createElement("span", {
        className: cnMenuTitle
      }, i18n.menu), /*#__PURE__*/React__default.createElement(MaterialDrop, null)), /*#__PURE__*/React__default.createElement(UserItem, {
        profile: profile,
        items: items,
        link: userLink,
        users: users,
        i18n: i18n,
        onShowAll: onShowAll,
        onLoginMore: onLoginMore,
        onOpen: onUserItemOpen,
        onUserClick: onUserClick,
        onForgetLogin: onForgetLogin
      }), /*#__PURE__*/React__default.createElement("div", {
        className: cnLogo
      }, /*#__PURE__*/React__default.createElement(Link, {
        link: "/".concat(locale),
        tabIndex: "-1",
        className: cnLogoLink,
        "data-type": "header",
        "data-function": "logo"
      }, /*#__PURE__*/React__default.createElement("img", {
        className: cnLogoImage,
        src: logoSource
      }))), /*#__PURE__*/React__default.createElement(Menu, {
        items: menuItems,
        open: open,
        languages: languages,
        innerRef: this.menu,
        onClose: function onClose() {
          _this4.setState({
            open: !open
          });
        },
        onLanguageSave: onLanguageSave,
        locale: locale,
        mobile: mobile,
        breakpoint: breakpoint,
        i18n: i18n,
        contactLink: contactLink
      })), /*#__PURE__*/React__default.createElement("div", {
        id: "toastPortal"
      }));
    }
  }]);

  return Header;
}(React__default.Component);
Header.propTypes = {
  /** */
  breakpoint: PropTypes.oneOf(Object.keys(globals.breakpoints)),

  /** URL to link to on contact clicked */
  contactLink: PropTypes.string.isRequired,

  /** True for fixed styling */
  fixed: PropTypes.bool,

  /** Translation object */
  i18n: PropTypes.shape(_rollupPluginBabelHelpers.objectSpread2(_rollupPluginBabelHelpers.objectSpread2({}, Menu.propTypes.i18n), {}, {
    menu: PropTypes.string.isRequired,
    changeUser: PropTypes.string.isRequired,
    showAll: PropTypes.string.isRequired,
    login: PropTypes.string.isRequired,
    loginMore: PropTypes.string.isRequired,
    labelModal: PropTypes.string.isRequired
  })).isRequired,

  /** Array of items for user item dropdown */
  items: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.shape())),

  /** Array of available languages */
  languages: PropTypes.array,

  /** Currently selected language code */
  locale: PropTypes.string,

  /** Path to loge */
  logoSource: PropTypes.string,

  /** Array of items for menu */
  menuItems: PropTypes.arrayOf(PropTypes.shape()),

  /** True for mobile styling */
  mobile: PropTypes.bool,

  /** Callback function on forget pw clicked */
  onForgetLogin: PropTypes.func,

  /** Callback function on language saved */
  onLanguageSave: PropTypes.func,

  /** Callback function on Login more */
  onLoginMore: PropTypes.func,

  /** Callback function on show all clicked */
  onShowAll: PropTypes.func,

  /** Callback function on user clicked */
  onUserClick: PropTypes.func,

  /** Callback function */
  onUserItemOpen: PropTypes.func,

  /** Profile object */
  profile: PropTypes.shape(),

  /** URL to link to on user clicked */
  userLink: PropTypes.string,

  /** Array of users */
  users: PropTypes.arrayOf(PropTypes.shape({
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    id: PropTypes.string,
    image: PropTypes.string
  }))
};
Header.defaultProps = {
  logoSource: '/public/assets/images/varta.logo.svg',
  fixed: true,
  i18n: {},
  languages: [],
  onShowAll: function onShowAll() {
    return void 0;
  },
  onLoginMore: function onLoginMore() {
    return void 0;
  },
  onUserItemOpen: function onUserItemOpen() {
    return void 0;
  },
  onUserClick: function onUserClick() {
    return void 0;
  }
};

module.exports = Header;
